import React, { useEffect, useState, useCallback, useContext } from 'react';
import {
    Select,
    Form,
} from 'antd';
import chart from '../../utils/chart'
import { QueryBuilder } from '@cubejs-client/react'
import dashboardFilter from '../../utils/dashboardFilter'
import useQueryUpdater from './useQueryUpdater'
import styles from './styles'
import PropTypes from 'prop-types'
import FilterContext from './FilterContext'

const DimFilterSelect = () => {

    const {
        filterState,
        handleFilterChange,
        dimensionOptions,
        state,
        setState
    } = useContext(FilterContext)

    /* useState */
    // const [filterState, setFilterState] = useState({})


    /* useQueryUpdater - custom hook */
    // const queryUpdater = useQueryUpdater()


    /* useCallback */
    /** 
     * @function updatedDimFilters update the dimension filters
     * @param {Object} dimension the dimension to be updated
     * @param {Array} v the values to set the dimension filters to
     * @returns {Object} the updated dashboard data
     */
    // const updatedDimFilters = useCallback((dimension, v) => {
    //     // get dashboard data from local storage
    //     let updatedData = {}
    //     updatedData['dashboardItems'] = chart.getLocalDashboardItems()

    //     updatedData.dashboardItems.forEach(async (dashboardItem) => {
    //         // update each dashboard item with new dimension filters
    //         let updatedVizState = JSON.parse(dashboardItem.vizState)

    //         updatedVizState.query.filters = dashboardFilter
    //             .mapValueToDimFilter(
    //                 dimension,
    //                 v,
    //                 updatedVizState.query.filters
    //             )
    //         dashboardItem.vizState = JSON.stringify(updatedVizState)
    //         await (await queryUpdater).updateQuery(dashboardItem)
    //     })

    //     return updatedData
    // })

    /** 
     * @function handleDimFilterChange called when a dimension filter is set
     * @param {Object} dim the dimension to be filtered
     * @param {Array} v the filter values
     */
    // const handleDimFilterChange = useCallback((dim, v) => {
    //     // update the state
    //     let newFState = {
    //         ...filterState,
    //     }
    //     newFState[dim.value] = v
    //     console.log("fState", newFState)
    //     // setFilterState(newFState)

    //     // @function updatedDimFilters
    //     const updatedData = updatedDimFilters(dim, v)
    //     // update the local storage and cache with new dashboard data Î
    //     // chart.setLocalDashboardItems(updatedData.dashboardItems)
    //     // chart.setDashboard(updatedData)
    // })

    // const resetDimFilters = useCallback(() => {
    //     let fState = dashboardFilter.resetAllDimFilters()
    //     // setFilterState(fState)
    //     chart.getLocalDashboardItems().forEach(async (dashboardItem) => {
    //         console.log(JSON.parse(dashboardItem.vizState).query.filters)
    //         await (await queryUpdater).updateQuery(dashboardItem)
    //     })
    // })


    /* useEffect */
    /** 
     * @function useEffect runs only on first render
     */
    useEffect(() => {
        // get dashboard data from local storage
        // let dashboardItems = chart.getLocalDashboardItems()

        // update the state to show current filters 
        // let fState = dashboardFilter
        //     .mapDimFilterToValue(dashboardItems[0])
        // setFilterState(fState)

    }, [])

    useEffect(() => {
        if (state.reset) {
            
            // resetDimFilters()
        }
    }, [state])


    return (
        <>
            {
                dimensionOptions.map((dOption, i) => (
                    <>
                        <Form.Item
                            style={{ paddingRight: 30 }}
                            label={
                                <label style={styles.formLabel()}>
                                    {`${dOption.label.toUpperCase()}`}
                                </label>
                            }>
                            <Select
                                mode='multiple'
                                allowClear
                                placeholder='All'
                                value={filterState[dOption.value]}
                                style={styles.inputSize()}
                                onChange={(v) => {
                                    handleFilterChange(dOption.value, v)
                                    // handleDimFilterChange(dOption, v)
                                }}
                                options={dOption.options}
                            />
                        </Form.Item>
                        {/* <div style={{ width: 40 }} /> */}
                    </>
                ))
            }
        </>
    )

}

DimFilterSelect.propTypes = {}
DimFilterSelect.defaultProps = {}

export default DimFilterSelect